import * as React from 'react';
import styled from 'styled-components';
import { BREAKPOINT, COLOR, MARGIN, PADDING } from '@latitude/core/utils/constants';
import { Box } from '@latitude/box';
import { Responsive } from '@latitude/spacing';

var Confetti1 = require("./svg/confetti1.svg");

var Confetti2 = require("./svg/confetti2.svg");

var InnerContainer = /*#__PURE__*/styled(Box).withConfig({
  displayName: "SingleTextBox__InnerContainer",
  componentId: "sc-tgs5v6-0"
})([""]);
var ContentBox = /*#__PURE__*/styled(Box).withConfig({
  displayName: "SingleTextBox__ContentBox",
  componentId: "sc-tgs5v6-1"
})(["position:relative;border:solid 20px ", ";background-color:", ";padding:", " 20px;width:100%;max-width:480px;@media (min-width:", "){padding:", " 60px;max-width:600px;}ul{margin:0 0 0 ", ";li{position:relative;list-style:none;margin:0 0 0 ", ";::before{font-size:36px;position:absolute;top:0;left:-", ";color:", ";content:'\u2022';}}}"], COLOR.BLUE_SKY, COLOR.WHITE, PADDING.P32, BREAKPOINT.MD, PADDING.P32, MARGIN.M16, MARGIN.M8, MARGIN.M24, COLOR.BLUE_LIGHT);
var StyledConfetti1 = /*#__PURE__*/styled(Confetti1).withConfig({
  displayName: "SingleTextBox__StyledConfetti1",
  componentId: "sc-tgs5v6-2"
})(["display:none;@media (min-width:", "){display:block;position:absolute;bottom:0;left:-100px;}"], BREAKPOINT.LG);
var StyledConfetti2 = /*#__PURE__*/styled(Confetti2).withConfig({
  displayName: "SingleTextBox__StyledConfetti2",
  componentId: "sc-tgs5v6-3"
})(["display:none;@media (min-width:", "){display:block;position:absolute;top:-30px;right:-95px;}"], BREAKPOINT.LG);
var OuterContainer = /*#__PURE__*/styled(Box).withConfig({
  displayName: "SingleTextBox__OuterContainer",
  componentId: "sc-tgs5v6-4"
})(["background-color:", ";padding:", " 0;position:relative;@media (min-width:", "){padding:0;}::before{content:'';width:100%;background-color:", ";display:block;height:70%;position:absolute;top:50%;transform:translateY(-50%);}"], COLOR.GREY6, PADDING.P24, BREAKPOINT.MD, COLOR.BLUE_BABY);
var ContentBoxContainer = /*#__PURE__*/styled(Box).withConfig({
  displayName: "SingleTextBox__ContentBoxContainer",
  componentId: "sc-tgs5v6-5"
})(["margin:", " ", ";padding:", " ", ";max-width:900px;"], MARGIN.M0, MARGIN.MAUTO, PADDING.P0, PADDING.P16);

var SingleTextBox = function SingleTextBox(_ref) {
  var box1 = _ref.box1,
      id = _ref.id;
  return /*#__PURE__*/React.createElement(OuterContainer, {
    id: id
  }, /*#__PURE__*/React.createElement(InnerContainer, null, /*#__PURE__*/React.createElement(ContentBoxContainer, null, /*#__PURE__*/React.createElement(Responsive, {
    spacing: MARGIN.M24
  }, /*#__PURE__*/React.createElement(ContentBox, null, /*#__PURE__*/React.createElement(StyledConfetti1, null), box1, /*#__PURE__*/React.createElement(StyledConfetti2, null))))));
};

export default SingleTextBox;